<template>
  <b-container fluid style="max-width: 1200px">
    <abaco-header :platform-url="platformUrl"/>

    <abaco-hero :form-url="formUrl" :sold-out="isCampaignSoldOut()"/>

    <abaco-faq :country="currentCountry"/>

    <abaco-product-slider :form-url="formUrl" :sold-out="isCampaignSoldOut()"/>

    <abaco-testimonials/>

    <abaco-partners :form-url="formUrl" :sold-out="isCampaignSoldOut()"/>

    <abaco-footer/>

    <abaco-choose-country :country="country" @onSelectCountry="countrySelected"/>

    <footer>
      <cookie-law theme="dark-lime"
                  buttonText="Aceptar"
                  message="Esta web utiliza cookies propias y de terceros para analizar y mejorar su experiencia de navegación.
Al continuar navegando, entendemos que acepta su uso."
      >
      </cookie-law>
    </footer>
  </b-container>
</template>

<script>
import CookieLaw from 'vue-cookie-law'
export default {
  name: 'App',
  components: { CookieLaw },
  props: {
    platformUrl: {
      type: String,
      default: 'https://plataforma.abacolatam.com/'
    },
    formUrls: {
      type: Object,
      default () {
        return {
          'co': 'formulario/microcreditos',
          82: 'formulario/microcreditos',
          'mx': 'formulario/microcredito',
          42: 'formulario/microcredito',
          'pe': 'formulario/microcreditos-peru',
          89: 'formulario/microcreditos-peru'
        }
      }
    },
    country: {
      type: String,
      default: 'co'
    }
  },
  build: {
    assetsPublicPath: '/frontend/src/assets/'
  },
  methods: {
    changeFormByCountry (country) {
      this.formUrl = this.formUrls[country]
      this.country = country
    },
    getCountryByCookie () {
      var name = 'country='
      var decodedCookie = decodeURIComponent(document.cookie)
      var ca = decodedCookie.split(';')
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i]
        while (c.charAt(0) === ' ') {
          c = c.substring(1)
        }
        if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length)
        }
      }
      return null
    },
    countrySelected (value) {
      this.country = value
      this.$router.go(this.$router.currentRoute)
    },
    isCampaignSoldOut () {
      return false
    }
  },
  mounted () {
    var country = this.getCountryByCookie()
    if (country === null) {
      country = 'co'
      this.$bvModal.show('countrySelect')
    }
    this.currentCountry = country
  },
  watch: {
    country: function () {
      this.changeFormByCountry(this.country)
    }
  },
  data () {
    var country = this.getCountryByCookie()
    return {
      formUrl: this.platformUrl + this.formUrls[country],
      currentCountry: country
    }
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Source+Serif+Pro:wght@700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500&display=swap');
.Cookie {
  z-index: 1000 !important;
}
.Cookie__button {
  border-radius: 25px !important;
}
@media (max-width: 575px) {
  .Cookie--dark-lime {
    padding-top: 5px !important;
    padding-bottom: 0 !important;
  }

  .Cookie__content {
    font-size: .75rem;
    margin: 2px;
  }

  .Cookie__buttons {
    margin-top: 2px;
    margin-bottom: 2px;
  }

  .Cookie__button {
    border-radius: 25px !important;
    font-size: .75rem !important;
  }
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 60px;
}
#app, body, html {
  padding: 0px;
  margin: 0;
  border: 0px;
  overflow-x: hidden; /* needed because hiding the menu on the right side is not perfect,  */
}
body {
  font-size: 16px;
  font-family: Inter, Helvetica, Arial, sans-serif;
}
.container {
  margin-top: 30px !important;
  padding: 0;
}
.underline-green {
  border-bottom: 2px solid #00C087;
  text-decoration: none;
}
.btn-cta-green {
  font-size: 1.1rem !important;
  height: 60px;
  color: #ffffff !important;
  border-radius: 33px !important;
  background-color: #00C087 !important;
  box-shadow: inset 0 -4px 0 0 rgba(0,0,0,0.17), 0 2px 3px 0 rgba(0,0,0,0.12);
  padding: 0.9em 2.6em 0.9em 2.6em !important;
}
.get-your-loan {
  height: 88px;
  width: 288px;
  color: #333333;
  font-family: "Source Serif Pro";
  font-weight: bold;
  letter-spacing: 0;
  line-height: 44px;
  text-align: center;
}
.section-title {
  font-size: 42px;
}
.section-title-green {
  color: #00C087;
}
@media (max-width: 575px) {
  .btn-cta {
    font-size: 1.4rem !important;
    padding-left: 40px !important;
    padding-right: 40px !important;
  }
  .btn-cta-green {
    font-size: 1.25rem !important;
    padding-top: 15px !important;
  }
}
@media (max-width: 400px) {
  .btn-cta {
    padding-left: 10px !important;
    padding-right: 10px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue